import DefaultLayout from "@/layouts/DefaultLayout";
import KLoginForm from "@/components/Auth/KLogin/KLoginForm";
import logo from "@/assets/logos/logo.png";
import { VBtn, VImg } from "vuetify/lib";

export default {
	name: "LoginPage",

	metaInfo: { title: "Log In" },

	render() {
		return <DefaultLayout maxWidth="300px">
			<VImg
				alt="Kinnect"
				class="mb-3 mx-auto"
				maxHeight={100}
				maxWidth={233}
				src={logo}
			></VImg>

			<KLoginForm></KLoginForm>

			<VBtn
				block
				class="mt-4"
				to={{ name: "register" }}
			>Request Access</VBtn>
		</DefaultLayout>;
	}
};
